import React from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'

import './styles.scss'

const UseFeatureProgressbar = ({ progress }) => {
	return (
		<div className="use-feature-progressbar">
			<CircularProgressbar
				maxValue={100}
				minValue={0}
				value={progress - 1}
				strokeWidth={6}
				text={<tspan>{progress}%</tspan>}
			/>
			<div className="progressbar-info">
				<h2 className="progressbar-info__title">
					Process your photo immediately...
				</h2>
				<p className="progressbar-info__text">
					Don’t close the page until the photo is complete.
				</p>
			</div>
		</div>
	)
}

export { UseFeatureProgressbar }
